





































import {Component, Prop, Vue} from 'vue-property-decorator';
@Component({})
export default class ConfirmationModal extends Vue {
	@Prop({default: 'Yes'}) public confirmButtonLabel: string;
	@Prop({default: 'Cancel'}) public cancelButtonLabel: string;

	@Prop({default: true}) public showCancelButton: boolean;
	@Prop() public confirmationTitle: string;
	@Prop() public confirmationMessage: string;
	@Prop() public typeConfirmationValidationMessage: string;
	public confirmValue: string = '';

	public get title() {
		return this.$sanitize(this.confirmationTitle);
	}
	public get message() {
		return this.$sanitize(this.confirmationMessage);
	}

	public get buttonDisabled() {
		return this.typedConfirmationRequired && !this.typedConfirmationValid;
	}

	public get typedConfirmationRequired(): boolean {
		return !!this.typeConfirmationValidationMessage;
	}

	public get typedConfirmationValid() {
		return this.typeConfirmationValidationMessage === this.confirmValue;
	}

	public confirm(): void {
		this.$emit('confirm');
	}
}
